import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Separator from '../../../../core/layout/Separator';
import AudioPreview from '../../../../core/layout/AudioPreview';
import ColumnSeparator from '../../../../core/layout/ColumnSeparator';
import Tag from '../../../../core/layout/Tag';
import Icon from '../../../../core/layout/Icon';
import VideoPreview from '../../../../core/layout/VideoPreview';

const ContentItem = (props) => {
  const firstItem = props.items[0];
  const typesWithSameOrder = ['VOCABULARY_ACADEMIC'];

  return (
    <div {...props}>
      <p
        style={{
          textAlign: 'center',
        }}
      >
        Type: {firstItem.type.name}
      </p>
      <p
        style={{
          textAlign: 'center',
        }}
      >
        Grammar: {get(firstItem.grammar, 'name', '-')}
      </p>
      <Separator size="sm" />
      {!!['PRESENTATION', 'TRUE_FALSE_KIDS', 'SINGLE_CHOICE_GAME', 'GAP_FILL_IMAGE', 'GAP_FILL_LETTER'].find(
        (type) => type === firstItem.type.key
      ) && (
        <div>
          <img
            src={`${process.env.REACT_APP_FILES_URL}/${firstItem.image}`}
            alt={firstItem.text}
            style={{
              margin: '0  auto',
              height: 250,
            }}
          />
          <Separator size="md" />
        </div>
      )}
      {!!['PHONEME'].find((type) => type === firstItem.type.key) && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 20,
          }}
        >
          <AudioPreview src={firstItem.titleAudio || firstItem.generatedTitleAudio} />
          <ColumnSeparator size="md" />
          <h1
            style={{
              margin: 0,
              fontSize: 24,
            }}
          >
            {firstItem.title}
          </h1>
        </div>
      )}
      {!!['VOCABULARY', 'CONNECTING_DOTS', 'PHONEME', 'MEMORY_GAME', 'VOCABULARY_GAME'].find(
        (type) => type === firstItem.type.key
      ) && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: '85%',
              margin: '0 auto',
            }}
          >
            <img
              src={`${process.env.REACT_APP_FILES_URL}/${firstItem.image}`}
              alt={firstItem.text}
              style={{
                margin: '0  auto',
                height: 250,
              }}
            />
            <Separator size="md" />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <AudioPreview src={firstItem.audio || firstItem.generatedAudio} />
              <ColumnSeparator size="md" />
              <div>
                <p
                  style={{
                    fontSize: 16,
                    marginBottom: 5,
                  }}
                >
                  {firstItem.text}
                </p>
                <span>
                  <i>{firstItem.translation || '-'}</i>
                </span>
              </div>
            </div>
          </div>
          <ColumnSeparator size="md" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: '85%',
              margin: '0 auto',
            }}
          >
            <img
              src={`${process.env.REACT_APP_FILES_URL}/${firstItem.postPhraseImage}`}
              alt={firstItem.text}
              style={{
                margin: '0  auto',
                height: 250,
              }}
            />
            <Separator size="md" />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <AudioPreview src={firstItem.postPhraseAudio || firstItem.generatedPostPhraseAudio} />
              <ColumnSeparator size="md" />
              <div>
                <p
                  style={{
                    fontSize: 16,
                    marginBottom: 5,
                  }}
                >
                  {firstItem.postPhrase}
                </p>
                <span>
                  <i>{'-'}</i>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {['VIDEO', 'VIDEO_SHORT', 'MUSIC', 'VIDEO_LONG'].some((type) => type === firstItem.type.key) && (
        <div style={{ width: 680, margin: 'auto' }}>
          <VideoPreview
            src={firstItem.videoExternalLink}
            videoStartTime={firstItem.videoStartTime}
            videoEndTime={firstItem.videoEndTime}
          />
        </div>
      )}
      {![
        'VIDEO',
        'MUSIC',
        'VOCABULARY',
        'CONNECTING_DOTS',
        'PHONEME',
        'MEMORY_GAME',
        'VOCABULARY_GAME',
        'AUDIO_LONG',
        'IMAGE',
        'UNSCRAMBLE_TEXT',
        'GRAMMAR_CHECK',
        'MEANINGS_ASSOCIATING',
        ...typesWithSameOrder,
      ].some((type) => type === firstItem.type.key) ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '85%',
            margin: '0 auto',
          }}
        >
          {!['VIDEO_SHORT', 'TEXT', 'SINGLE_CHOICE_GAME', 'VIDEO_LONG'].some((type) => type === firstItem.type.key) && (
            <React.Fragment>
              <AudioPreview src={firstItem.audio || firstItem.generatedAudio} />
              <ColumnSeparator size="sm" />
            </React.Fragment>
          )}
          <div>
            <p
              style={{
                fontSize: 16,
                marginBottom: 5,
              }}
            >
              {firstItem.text}
            </p>
            <span>
              <i>{firstItem.translation || '-'}</i>
            </span>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '85%',
            margin: '0 auto',
          }}
        >
          {get(firstItem, 'subtitles', []).map((item) => (
            <p
              key={item.start}
              style={{
                display: 'block',
                fontSize: 16,
                marginBottom: 5,
              }}
            >
              {item.text}
            </p>
          ))}
        </div>
      )}
      <Separator size="md" />
      {!![
        'GAP_FILL_MULTIPLE',
        'GAP_FILL_SELECT',
        'GAP_FILL_IMAGE',
        'GAP_FILL_LETTER',
        'GAP_FILL',
        'UNSCRAMBLE_DRAG_AND_DROP',
        'UNSCRAMBLE_SPEECH_RECOGNITION',
      ].find((type) => type === firstItem.type.key) && (
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <span>Gaps Preview:</span>
          <div>
            {(firstItem.type.key === 'GAP_FILL_LETTER' ? [...firstItem.text] : firstItem.text.split(' ')).map(
              (slice, index) => (
                <span>{firstItem.answers.find((answer) => answer.index === index) ? ' -- ' : slice.concat(' ')}</span>
              )
            )}
          </div>
          <Separator size="md" />
        </div>
      )}
      {!![
        'SINGLE_CHOICE_TEXT',
        'SINGLE_CHOICE_IMAGE',
        'SINGLE_CHOICE_AUDIO',
        'GAP_FILL_MULTIPLE',
        'GAP_FILL_SELECT',
        'GAP_FILL_IMAGE',
        'GAP_FILL_LETTER',
        'GAP_FILL',
        'TRUE_FALSE',
        'TRUE_FALSE_KIDS',
        'DICTATION',
        'UNSCRAMBLE_DRAG_AND_DROP',
        'UNSCRAMBLE_SPEECH_RECOGNITION',
        'SINGLE_CHOICE_GAME',
        'MULTIPLE_CHOICE_TEXT',
        'GRAMMAR_CHECK',
      ].find((type) => type === firstItem.type.key) && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <span>Options:</span>
          <Separator size="xs" />
          <div>
            {firstItem.linkedAnswers.map((answer) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: 5,
                }}
              >
                {answer.image && (
                  <div>
                    <img
                      alt={answer.text}
                      src={`${process.env.REACT_APP_FILES_URL}/${answer.image}`}
                      style={{
                        width: 140,
                        display: 'inline-block',
                      }}
                    />
                    <ColumnSeparator size="xs" />
                  </div>
                )}
                <Tag color={answer.correct ? 'green' : 'red'}>
                  {answer.correct ? <Icon name="check" /> : <Icon name="close" />}
                </Tag>
                <ColumnSeparator size="xs" />
                {(answer.audio || answer.generatedAudio) && (
                  <div>
                    <AudioPreview src={answer.audio || answer.generatedAudio} />
                    <ColumnSeparator size="xs" />
                  </div>
                )}
                <span
                  style={{
                    fontSize: 16,
                  }}
                >
                  {answer.text}
                </span>
              </div>
            ))}
          </div>
          <Separator size="md" />
        </div>
      )}
      {!!['AUDIO_LONG'].find((type) => type === firstItem.type.key) && firstItem.audio && (
        <div
          style={{
            marginTop: '25px',
            marginBottom: '5px',
            fontWeight: 'bold',
          }}
        >
          <AudioPreview src={firstItem.audio} />
          <span
            style={{
              marginTop: '25px',
              marginBottom: '5px',
              fontWeight: 'bold',
            }}
          >
            Audio transcription:
          </span>
          <p
            style={{
              textAlign: 'center',
            }}
          >
            {firstItem.text}
          </p>
        </div>
      )}
      {!!['IMAGE'].find((type) => type === firstItem.type.key) && firstItem.image && (
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <img
            alt={firstItem.text}
            src={`${process.env.REACT_APP_FILES_URL}/${firstItem.image}`}
            style={{
              width: '350px',
              display: 'inline-block',
            }}
          />
          <ColumnSeparator size="xs" />
          <span
            style={{
              marginTop: '25px',
              marginBottom: '5px',
              fontWeight: 'bold',
            }}
          >
            Image description:
          </span>
          <p
            style={{
              textAlign: 'center',
            }}
          >
            {firstItem.text || 'N/A'}
          </p>
        </div>
      )}
      {!!['UNSCRAMBLE_TEXT'].find((type) => type === firstItem.type.key) && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '50%',
            margin: '0 auto',
          }}
        >
          {firstItem.text.split('\n').map((paragraph, index) => (
            <p style={{ margin: '15px 0' }}>
              <b>{index + 1}. </b>
              {paragraph}
            </p>
          ))}
        </div>
      )}
      {!!typesWithSameOrder.find((type) => type === firstItem.type.key) &&
        firstItem.type.key === 'VOCABULARY_ACADEMIC' &&
        props.items.map((item) => (
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '800px', margin: '10px auto' }}>
            <div style={{ width: '200px' }}>
              <img
                src={`${process.env.REACT_APP_FILES_URL}/${item.image}`}
                alt={item.text}
                style={{
                  width: '100%',
                }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: '40px',
              }}
            >
              <React.Fragment>
                <AudioPreview src={item.audio || item.generatedAudio} />
                <ColumnSeparator size="sm" />
              </React.Fragment>
              <div>
                <p
                  style={{
                    fontSize: 16,
                    marginBottom: 5,
                  }}
                >
                  {item.text}
                </p>
                <p
                  style={{
                    fontSize: 16,
                    marginBottom: 5,
                  }}
                >
                  {item.postPhrase}
                </p>
                <span>
                  <i>{item.translation || '-'}</i>
                </span>
              </div>
            </div>
            <Separator size="lg" />
          </div>
        ))}
      <Separator size="lg" />
      {!!['GRAMMAR_CHECK'].find((type) => type === firstItem.type.key) && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '50%',
            margin: '0 auto',
          }}
        >
          <div>
            <span>
              <b>Text:</b>
            </span>
            <p>
              {firstItem.text
                .trim()
                .split(' ')
                .map((word, index) => {
                  if (!!firstItem.slices.find((slice) => slice.index === index)) {
                    return <span style={{ color: 'red', marginRight: '3px' }}>{word}</span>;
                  }
                  return <span style={{ marginRight: '3px' }}>{word}</span>;
                })}
            </p>
          </div>
          <div>
            <span>
              <b>Answers:</b>
            </span>
            <ul>
              {firstItem.answers.map((answer) => {
                return (
                  <li>
                    {answer.text
                      .trim()
                      .split(' ')
                      .map((word, index) =>
                        !!answer.slices.find((slice) => slice.index === index) ? (
                          <span style={{ color: 'green', marginRight: '3px' }}>{word}</span>
                        ) : (
                          <span style={{ marginRight: '3px' }}>{word}</span>
                        )
                      )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
      <Separator size="lg" />
      {firstItem.type.key === 'MEANINGS_ASSOCIATING' && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: '85%',
              margin: '0 auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <AudioPreview src={firstItem.audio || firstItem.generatedAudio} />
              <ColumnSeparator size="md" />
              <div>
                <p
                  style={{
                    fontSize: 16,
                    marginBottom: 5,
                  }}
                >
                  {firstItem.text}
                </p>
                <span>
                  <i>{'-'}</i>
                </span>
              </div>
            </div>
          </div>
          <ColumnSeparator size="md" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: '85%',
              margin: '0 auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <AudioPreview src={firstItem.postPhraseAudio || firstItem.generatedPostPhraseAudio} />
              <ColumnSeparator size="md" />
              <div>
                <p
                  style={{
                    fontSize: 16,
                    marginBottom: 5,
                  }}
                >
                  {firstItem.postPhrase}
                </p>
                <span>
                  <i>{firstItem.translation || '-'}</i>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      <Separator size="lg" />
    </div>
  );
};

ContentItem.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      translation: PropTypes.string,
      grammar: PropTypes.shape({
        name: PropTypes.string,
      }),
      type: PropTypes.shape({
        name: PropTypes.string,
        key: PropTypes.string,
      }),
      image: PropTypes.string,
      audio: PropTypes.string,
      generatedAudio: PropTypes.string,
      answers: PropTypes.arrayOf(
        PropTypes.shape({
          index: PropTypes.number,
        })
      ),
      linkedAnswers: PropTypes.arrayOf(
        PropTypes.shape({
          index: PropTypes.number,
          text: PropTypes.string,
          audio: PropTypes.string,
          generatedAudio: PropTypes.string,
          image: PropTypes.string,
          correct: PropTypes.bool,
        })
      ),
    })
  ).isRequired,
};

export default ContentItem;
